import React from "react";
import { Button, Tooltip } from "@mui/material";

interface TranscribeButtonProps {
  postId?: string;
  mediaIndex: number;
  userToken?: string;
  onTranscript: (transcript: string, updatedPost?: any) => void;
  disabled?: boolean;
}

const TranscribeButton: React.FC<TranscribeButtonProps> = ({
  postId,
  mediaIndex,
  userToken,
  onTranscript,
  disabled,
}) => {
  const [loading, setLoading] = React.useState(false);

  const handleTranscribe = async () => {
    if (!postId) return;
    setLoading(true);
    try {
      const res = await fetch(
        `/api/blog/${postId}/retranscribe_audio/${mediaIndex}`,
        {
          method: "POST",
          headers: userToken
            ? { Authorization: `Bearer ${userToken}` }
            : undefined,
        }
      );
      if (!res.ok) throw new Error("Transcription failed");
      const updated = await res.json();
      const transcript = updated.media?.[mediaIndex]?.data?.transcript || "";
      onTranscript(transcript, updated);
    } catch (e: any) {
      alert(e.message || "Transcription error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip
      title={!postId ? "Save the post first to enable transcription" : ""}
    >
      <span>
        <Button
          variant="outlined"
          onClick={handleTranscribe}
          disabled={loading || disabled || !postId}
          sx={{ ml: 1 }}
        >
          {loading ? "Transcribing..." : "Transcribe"}
        </Button>
      </span>
    </Tooltip>
  );
};

export default TranscribeButton;
